import PropTypes from 'prop-types';

import { Desktop } from 'core/components/breakpoint';
import Text from 'core/components/Text';
import MarkdownWrapper from 'core/components/MarkdownWrapper';
import { markdownRenderers } from 'core/components/About';

import styles from './index.styl';


export default function Agenda({ about, logo }) {
  if (!about) return null;

  return (
    <div className={styles.agenda}>
      <Text>
        <MarkdownWrapper interitemSpacing={14} components={markdownRenderers}>{about}</MarkdownWrapper>
      </Text>
      {logo && (
        <Desktop>
          <div className={styles.logo}>
            {logo}
          </div>
        </Desktop>
      )}
    </div>
  );
}

Agenda.propTypes = {
  about: PropTypes.string,
  logo: PropTypes.node,
};
